import { ObservableFromFetch } from "../ObservableFromFetch"
import TestToMergeViewModel, {MergeEventParameters} from "./OrderResultModel/TestToMergeRecord"
import { Filter, Sort } from "../GridRequest"

export function TestToMergeGetObservable(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }, testDetailID: string, testType: string) {
  const requestBody: string = JSON.stringify({
    BatchPool: "",
    BySel: search.field,
    Filters: {
      ID: filters.find(filter => filter.column === "ID")?.values || [],
      Name: filters.find(filter => filter.column === "Name")?.values || [],
      DateCollected: filters.find(filter => filter.column === "DateCollected")?.values || [],
      Reason: filters.find(filter => filter.column === "Reason")?.values || [],
      Type: filters.find(filter => filter.column === "Type")?.values || [],
      Result: filters.find(filter => filter.column === "Result")?.values || [],
      Status: filters.find(filter => filter.column === "Status")?.values || [],
      Company: filters.find(filter => filter.column === "Company")?.values || [],
    },
    MatchSel: "Partial",
    PageNumber: pageNumber,
    PageSize: pageSize,
    SortGrid: { SortColumn: sort.column, SortOrder: sort.order.toUpperCase() === "DESC" ? "DSC" : sort.order.toUpperCase() },
    SrchFor:  search.text,
    TypeSel: "",
    TestDetailID: testDetailID,
    TestType: testType
    
  })

  return ObservableFromFetch<TestToMergeViewModel>("WorkForceTrack/SearchTestsToMerge", requestBody)
}
export  function MergeTest(data: MergeEventParameters) {
  const requestBody = JSON.stringify({
    TestDetailID: data.TestDetailID,
    MergeTestDetailID: data.MergeTestDetailID,
    MergeMode: data.MergeMode,
    KeepReleased: data.KeepReleased
  })

  return ObservableFromFetch<string>("WorkForceTrack/MergeTest", requestBody)
}